// extracted by mini-css-extract-plugin
export default {"stickyNav":"sticky-side-navigation-module--sticky-nav--82c66","number":"sticky-side-navigation-module--number--38c72","active":"sticky-side-navigation-module--active--043c3"};